import { useLocation } from "react-router-dom";

const BOOKING_URL = "https://booking.wellnessacademyusa.com/booking-page-wellness-academy";

const StickyBottomBar = () => {
  const { pathname } = useLocation();
  const isRetreats = pathname.startsWith("/retreats");
  const label = isRetreats ? "Explore Our Retreat" : "Explore Our Wellness Programs";

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-secondary pb-[env(safe-area-inset-bottom)]"
    >
      <div className="border-t border-foreground/20">
        <div className="max-w-6xl mx-auto px-2 sm:px-8 flex items-center justify-between min-h-14">
          <p className="font-sans text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-foreground hidden sm:block">
            {label}
          </p>
          <div className="grid w-full grid-cols-3 gap-2 text-center sm:flex sm:w-auto sm:items-center sm:gap-3 sm:ml-auto [&>a]:flex [&>a]:min-h-11 [&>a]:items-center [&>a]:justify-center [&>a]:min-w-0">
            <a
              href="/nutrition"
              className="font-sans text-[10px] sm:text-xs uppercase tracking-[0.1em] sm:tracking-[0.15em] text-foreground border border-foreground/30 px-3 sm:px-5 py-1.5 sm:py-2 hover:bg-foreground/5 transition-colors"
            >
              Nutrition &amp; Culinary
            </a>
            <a
              href="/physical-activity-training"
              className="font-sans text-[10px] sm:text-xs uppercase tracking-[0.1em] sm:tracking-[0.15em] text-foreground border border-foreground/30 px-3 sm:px-5 py-1.5 sm:py-2 hover:bg-foreground/5 transition-colors"
            >
              Physical Activity
            </a>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-[10px] sm:text-xs uppercase tracking-[0.1em] sm:tracking-[0.15em] bg-nav text-nav-text px-3 sm:px-5 py-1.5 sm:py-2 hover:bg-nav/90 transition-colors"
            >
              Book a Consultation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyBottomBar;
